<template>
  <tea-main @back="goBack">
    <template slot="nav">
      <div class="blackListNav">
        <div class="main_wrap">
          <div class="left" v-if="localUserInfo.member_type !== 'teacher'">
            <a
              v-for="(item, index) in nav"
              :key="index"
              :class="{ btn: true, active: index == idx }"
              @click="switchTab(index, item.object_type)"
              >{{ item.name }}</a
            >
          </div>
          <div class="left" v-else>
            <a
              v-for="(item, index) in nav"
              :key="index"
              :class="{ btn: true, active: index == idx }"
              >{{ item.name }}</a
            >
          </div>
          <div
            class="zuxie-btn"
            @click="addFunc"
            v-if="
              idx === 0 &&
              localUserInfo.member_type !== 'organ' &&
              localUserInfo.member_type !== 'orgFive'&&
              localUserInfo.member_type !== 'teacher'
            "
          >
            添加文件存档
          </div>
          <div
            class="zuxie-btn"
            @click="addFuncOrg"
            v-if="
              idx === 2 &&
              (localUserInfo.member_type == 'organ' ||
                localUserInfo.member_type == 'orgFive')
            "
          >
            添加文件存档
          </div>
        </div>
      </div>
    </template>
    <template slot="main">
      <div class="blackListMain">
        <div class="searchWrap">
          <div class="search">
            <div class="leisureBtn">
              <!--  // 。。。 删除了部分-->
            </div>
            <div class="wrap">
              <input
                v-model.lazy="search.keywords"
                type="text"
                placeholder="请输入搜索内容"
                @keyup.enter="getRequest"
              />
              <div
                v-show="search.keywords != ''"
                class="close"
                @click="hideIcon"
              >
                <v-icon name="regular/times-circle" scale="1.2"></v-icon>
              </div>
              <div class="searchBtn" @click="getRequest">搜索</div>
            </div>
          </div>
        </div>
        <yioks-loading v-show="isLoading"></yioks-loading>
        <template v-if="!isLoading">
          <template v-if="showList">
            <div class="table" v-if="idx === 0">
              <div class="thead">
                <div class="tr">
                  <div class="th index"><strong>序号</strong></div>
                  <div class="th name"><strong>姓名/详情</strong></div>
                  <div class="th mobile_phone"><strong>手机号</strong></div>
                  <div class="th id_number">
                    <strong>身份有效证件号</strong>
                  </div>
                  <div class="th banned_time"><strong>上传日期</strong></div>
                  <div class="th title_name"><strong>文件标题</strong></div>
                  <div class="th opt"><strong>操作</strong></div>
                </div>
              </div>
              <div class="scrollArea" v-if="showList">
                <vue-scroll :ops="ops" ref="vs">
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in tableList"
                        :key="index"
                      >
                        <div class="td index">
                          <p>{{ index+1 }}</p>
                        </div>
                        <div class="td name">
                          <p
                            class="showRecord"
                            @click="stuView(item.uid)"
                            v-if="
                              item.uid &&
                              localUserInfo.member_type !== 'organ' &&
                              localUserInfo.member_type !== 'orgFive'&&
                              localUserInfo.member_type !== 'teacher'
                            "
                          >
                            {{ item.coach_name }}
                          </p>
                          <p v-else style="color: #ffffff">
                            {{ item.coach_name }}
                          </p>
                        </div>
                        <div class="td mobile_phone">
                          <p>{{ item.coach_mobile_phone || "--" }}</p>
                        </div>
                        <div class="td id_number">
                          <p>{{ item.id_number || "--" }}</p>
                        </div>
                        <div class="td banned_time">
                          <p>{{ item.create_time | time(false) }}</p>
                        </div>
                        <div class="td title_name">
                          <p :title="item.credential_title">
                            {{ item.credential_title || "--" }}
                          </p>
                        </div>
                        <div class="td opt">
                          <span @click="lookOver(item)">查看</span>
                          <span
                            v-if="
                              item.author_user_id === localUserInfo.user_id ||
                              (localUserInfo.member_type !== 'organ' &&
                                localUserInfo.member_type !== 'orgFive'&&
                                localUserInfo.member_type !== 'teacher')
                            "
                            >&nbsp;/&nbsp;</span
                          >
                          <span
                            @click="deleteOver(item)"
                            v-if="
                              item.author_user_id === localUserInfo.user_id ||
                              (localUserInfo.member_type !== 'organ' &&
                                localUserInfo.member_type !== 'orgFive'&&
                                localUserInfo.member_type !== 'teacher')
                            "
                            :data-memberType="localUserInfo.member_type"
                            >删除</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
            <div class="table" v-if="idx === 1 || idx === 2">
              <div class="thead">
                <div class="tr">
                  <div class="th index"><strong>序号</strong></div>
                  <div class="th classname">
                    <strong>{{
                      idx === 1 ? "培训班名称" : "会员协会名称"
                    }}</strong>
                  </div>
                  <div class="th banned_time"><strong>上传日期</strong></div>
                  <div class="th title_name"><strong>文件标题</strong></div>
                  <div class="th opt"><strong>操作</strong></div>
                </div>
              </div>
              <div class="scrollArea" v-if="showList">
                <vue-scroll :ops="ops" ref="vs">
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in tableList"
                        :key="index"
                      >
                        <div class="td index">
                          <p>{{ index+1 }}</p>
                        </div>
                        <div class="td classname">
                          <template
                            v-if="
                              localUserInfo.member_type !== 'organ' &&
                              localUserInfo.member_type !== 'orgFive'&&
                              localUserInfo.member_type !== 'teacher'
                            "
                          >
                            <p
                              class="showRecord"
                              @click="lookOverClass(item.id_number)"
                              v-if="idx === 1"
                            >
                              {{ item.coach_name }}
                            </p>
                            <p
                              class="showRecord"
                              @click="lookOverOrg(item.id_number)"
                              v-else
                            >
                              {{ item.coach_name }}
                            </p>
                          </template>
                          <template v-else>
                            <p style="color: #ffffff" v-if="idx === 1">
                              {{ item.coach_name }}
                            </p>
                            <p style="color: #ffffff" v-else>
                              {{ item.coach_name }}
                            </p>
                          </template>
                        </div>
                        <div class="td banned_time">
                          <p>{{ item.create_time | time(false) }}</p>
                        </div>
                        <div class="td title_name">
                          <p :title="item.credential_title">
                            {{ item.credential_title || "--" }}
                          </p>
                        </div>
                        <div class="td opt">
                          <span @click="lookOver(item)">查看</span>
                          <span
                            v-if="
                              item.author_user_id === localUserInfo.user_id ||
                              (localUserInfo.member_type !== 'organ' &&
                                localUserInfo.member_type !== 'orgFive'&&
                                localUserInfo.member_type !== 'teacher')
                            "
                            >&nbsp;/&nbsp;</span
                          >
                          <span
                            @click="deleteOver(item)"
                            v-if="
                              item.author_user_id === localUserInfo.user_id ||
                              (localUserInfo.member_type !== 'organ' &&
                                localUserInfo.member_type !== 'orgFive'&&
                                localUserInfo.member_type !== 'teacher')
                            "
                            >删除</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
            <div id="paging">
              <yioks-paging
                :paging="paging"
                @goto-page="gotoPage($event)"
              ></yioks-paging>
            </div>
          </template>
          <!--  查看文件详情  -->
          <div v-if="t_show">
            <details-dialog
              :dialogTitle="Title"
              :isShowAddDialog.sync="t_show"
              :dialogData="documentDialog"
            />
          </div>

          <!--  添加文件  -->
          <!--<div v-if="add_show">-->
          <!--<add-dialog :addTitle="addtitles" :isAddDialog.sync="add_show" :addData="add_datas"/>-->
          <!--</div>-->

          <yioks-empty v-show="showEmpty"></yioks-empty>

          <template v-if="showDeleteDialog">
            <yioks-dialog
              :showTips.sync="showDeleteDialog"
              :tips="`确定删除该文件存档吗?`"
              @hideTips="hideDeleteDialog"
            ></yioks-dialog>
          </template>
          <template v-if="add_show">
            <add-dialog
              :showAddDialog="add_show"
              :Info="{}"
              @hideTips="hideAddDocumentTips"
            ></add-dialog>
          </template>
          <template v-if="add_show_org">
            <add-dialog
              :showAddDialog="add_show_org"
              :Info="{
                name: orgInfo.org_abbreviation,
                id_number: orgInfo.org_id,
                mobile_phone: '',
                object_type: 'organ',
              }"
              @hideTips="hideAddDocumentTipsForOrg"
            ></add-dialog>
          </template>
        </template>
      </div>
    </template>
  </tea-main>
</template>

<script>
import {
  getDocumentList,
  findDocunmentDetails,
  deleteCredential,
} from "@/api/document/document";
import { storageData } from "@/assets/js/storage";
import ops from "@/assets/js/vuescrollOption";
import { mapMutations, mapActions, mapGetters } from "vuex";
const testType = (value) =>
  Object.prototype.toString.call(value).slice(8, -1).toLocaleLowerCase();
const user_type = storageData.getUserType();
export default {
  name: "Documents",
  data() {
    const nav = user_type==='teacher' ? [
      
      {
        name: "培训班文件存档",
        object_type: "class",
      },
      
    ] :[
      {
        name: "讲师 / 学员文件存档",
        object_type: "",
      },
      {
        name: "培训班文件存档",
        object_type: "class",
      },
      {
        name: "会员协会文件存档",
        object_type: "organ",
      },
    ];
    return {
      localUserInfo: storageData.getUserInfo(),
      nav: nav,
      idx: 0, // nav 下标
      tableList: [],
      documentDialog: {},
      t_show: false,
      addtitles: "",
      add_show: false,
      add_datas: {},
      // *********************
      ops: ops(),
      index: 0,
      credential_uuid: "",
      name: "",
      isLoading: true,
      deleteLoading: false,
      showDeleteDialog: false,
      notEdit: false,
      Title: "详细信息",
      showList: false,
      showEmpty: false,
      Info: {},
      page: 1,
      paging: {
        start: 0,
        prePage: 1, // 一页多少条数据
        total: 0, // 总页数
        size: 3, // 页码显示限制
        last: true, // 尾页
        next: true, // 下一页
        first: true, // 首页
        previous: true, // 上一页
        jump: true,
      },
      search: {
        keywords: "",
        id_number: "",
        object_type: "",
      },
      add_show_org: false,
      orgInfo: {},
    };
  },
  computed: {
    ...mapGetters(["getStoreOrgData"]),
  },
  components: {
    "details-dialog": () => import("./components/SeeDetails"),
    "add-dialog": () => import("./components/AddDialog"),
    "tea-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-paging": () => import("@/components/Pagination/Page"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-verify": () => import("@/components/Tips/reviewDialog"),
    "yioks-dialog": () => import("@/components/Tips/Dialog"),
  },
  watch: {
    getStoreOrgData: {
      handler(val) {
        if (testType(val) === "object") {
          this.orgInfo = { ...val };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.setData();
    this.request();
    this.actionStoreOrgData();
  },
  methods: {
    // 修改
    addFunc() {
      this.add_show = true;
    },
    stuView(uid) {
      this.$router.push({ path: "st", query: { id: uid } });
    },
    //切换tab
    switchTab(idx, object_type) {
      if (idx === this.idx) {
        return;
      }
      this.showEmpty = false;
      this.$set(this.search, "keywords", "");
      this.$set(this.search, "object_type", object_type);
      this.$set(this.search, "id_number", "");
      //            this.$set(this.search, "page", "");
      this.idx = idx;
      this.changeQuery(true);
    },
    // 查看详情
    lookOver(item) {
      const { credential_uuid } = item;
      findDocunmentDetails(credential_uuid)
        .then((res) => {
          const { result } = res.data;
          this.documentDialog = result;
          this.t_show = true;
          this.Title = "文件存档详情";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    lookOverClass(id) {
      this.$router.push({ path: "class_detail", query: { c_id: id } });
    },
    lookOverOrg(id) {
      this.$router.push({ path: "od", query: { id: id } });
    },
    // ************************************** end ****************************************
    setData() {
      const { idx, page, keywords, id_number, object_type } = this.$route.query;
      page && (this.page = page);
      (Number(idx) === 0 || idx) && (this.idx = Number(idx));
      keywords && this.$set(this.search, "keywords", keywords);
      object_type && this.$set(this.search, "object_type", object_type);
      id_number && this.$set(this.search, "id_number", id_number);
    },
    goBack() {
      if (this.$route.query.id_number) {
        this.$router.go(-1);
      } else {
        this.$router.push("sm");
      }
    },
    request() {
      this.isLoading = true;
      getDocumentList({ page: this.page, ...this.search })
        .then((res) => {
          if (res.data.status === 0) {
            const { result } = res.data;
            this.tableList = res.data.result.list;
            this.showList = result.list.length > 0;
            this.showEmpty = !this.showList;
            this.isLoading = false;
            this.$set(this.paging, "prePage", result.page.page_size);
            this.$set(this.paging, "total", result.page.total_row);
            this.$set(
              this.paging,
              "start",
              (this.page - 1) * this.paging.prePage
            );
          } else {
            this.$message.error(res.data.msg);
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },
    hideIcon() {
      this.$set(this.search, "keywords", "");
      this.getRequest();
    },
    hideTimeIcon() {
      this.$set(this.search, "start_date", "");
      this.$set(this.search, "end_date", "");
      this.getRequest();
    },
    getRequest() {
      this.changeQuery(true);
    },
    gotoPage: function (start) {
      this.page = parseInt(start / this.paging.prePage) + 1;
      this.changeQuery(false);
      this.$refs["vs"].scrollTo({ y: 0 });
    },
    changeQuery(flag) {
      flag && (this.page = 1);
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          idx: this.idx,
          page: this.page,
          keywords: this.search.keywords,
          object_type: this.search.object_type,
          id_number: this.search.id_number,
        },
      });
      this.request();
    },
    deleteOver(item) {
      this.credential_uuid = item.credential_uuid;
      this.showDeleteDialog = true;
    },

    hideDeleteDialog(bool, flag) {
      if (flag) {
        this.deleteLoading = true;
        deleteCredential({
          credential_uuid: this.credential_uuid,
        })
          .then((res) => {
            if (Number(res.data.status) === 0) {
              this.$message.success("删除成功！");
              this.request();
            } else {
              this.$message.error(res.data.msg);
            }
            this.deleteLoading = false;
          })
          .catch((err) => {
            this.deleteLoading = false;
            this.showDeleteDialog = false;
          });
      }
      this.showDeleteDialog = bool;
    },

    hideAddDocumentTips(bool, flag) {
      this.add_show = bool;
      if (flag) {
        this.$message.success("添加成功！");
        this.request();
      }
    },

    hideAddDocumentTipsForOrg(bool, flag) {
      this.add_show_org = bool;
      if (flag) {
        this.$message.success("添加成功！");
        this.request();
      }
    },
    addFuncOrg() {
      this.add_show_org = true;
    },
    ...mapActions(["actionStoreOrgData"]),
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/nav_filter'
.blackListNav, .blackListMain
  flex 1 1 auto
  height 100%
.blackListNav
  display flex
  justify-content space-between
  align-items center
  padding 0 12px 0 0
  font-size $font_size_big
  .main_wrap
    display flex
    flex 1
    justify-content space-between
    align-items center
    .left, .right
      display flex
      align-items center
      .btn
        padding 5px 15px
        cursor pointer
        &.active
          background-color $color_suc
        &+.btn
          margin-left 10px
.blackListMain
  width 100%
  padding 25px 0 0
  background-color $block_bg_color_base
  .searchWrap
    display flex
    justify-content space-between
    align-items center
    height 40px
    margin 0 40px
    .search
      width 100%
      height 100%
      display flex
      justify-content space-between
      align-items center
      .wrap
        height 100%
        display flex
        position relative
        input
          width 220px
          height 100%
          padding 0 20px
          font-size $font_size_medium
          color $color_black
          outline none
        .close
          position absolute
          right 95px
          top 10px
          color $color_info
          cursor pointer
        .searchBtn
          width 90px
          height 100%
          display flex
          justify-content center
          align-items center
          font-size 20px
          background-color $color_suc
          cursor pointer
      .leisureBtn
        position relative
        display flex
        height 100%
        .close
          position absolute
          right 175px
          top 10px
          color $color_info
          cursor pointer
        /* .timePicker{
            border-radius 0
            width 280px
            margin-right 20px
            span{
                padding 0
            }
        } */
        select
          width 150px
          height 100%
          padding 0 15px
          font-size $font_size_medium
          color $color_black
          cursor pointer
          outline none
          &+select
            margin-left 15px
  .table
    width 100%
    margin 30px 0 0
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      height 401px
    .tbodyWrap
      display block
      margin-bottom 10px
      // padding: 0 40px;
    .tbody
      display block
      margin-left auto
      margin-right auto
      width 810px
      max-width 810px
      border-top none
      border-bottom none
      .tr
        height 49px
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height 100%
      flex 1 1 auto
      display flex
      justify-content center
      align-items center
      font-size 16px
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td:last-child
      color $color_suc
      user-select none
    .td
      p
        over_hide()
      .showRecord
        cursor pointer
        color $color_suc
        user-select none
    .index
      width 6%
    .classname
      width 48%
    .name
      width 15%
    .mobile_phone
      width 13%
    .id_number
      width 21%
    .banned_time
      width 13%
    .title_name
      width 21%
    .opt
      width 11%
      span
        cursor pointer
        color $color_suc
  #paging
    width 100%
    height 77px
</style>

<style lang="stylus" >
.blackListMain
  .el-date-editor .el-range-separator
    padding 0
  .__vuescroll .__view
    min-height 96%
</style>
